<template>
  <div class="product-gallery">
    <template v-if="media.length > 0">
      <div class="product-gallery__holder">
        <label id="imgPreviousBtn">
          <button aria-label="Previous image" v-if="media.length > 1" @click="galleryPrevious">
            <Icon
class="product-gallery__button" name="chevron-left" size="44px" />
          </button>
        </label>
        <flickity ref="flickity"
:options="flickityOptions" class="product-gallery-main" role="region" aria-label="Product Image Slider">
          <template v-for="(mediaItem, mediaIndex) in media">
            <div v-if="mediaItem.media_type == 'image'"
class="carousel-cell carousel-cell-zoom" :key="mediaItem.id" @mousemove="zoom">
              <img
class="product-gallery__image lazyload image--fade-in" :data-src="mediaItem.src" data-widths="[400,500,600,700,800,900,1000,1100,1200]" data-sizes="auto" :alt="mediaItem.alt ? mediaItem.alt : `${productTitle} Image ${mediaIndex + 1}`" />
              <div v-lazy:background-image="zoomImages[mediaIndex]" class="product-gallery__image--zoom" />
            </div>
            <div v-else-if="mediaItem.media_type == 'video'"
class="carousel-cell" :key="mediaItem.id">
              <div class="video-wrapper video-wrapper--native"
:style="videoPadding(mediaIndex)">
                <video class="product-gallery__video"
muted controls playsinline>
                  <source
:src="mediaItem.sources[0].url" :type="mediaItem.sources[0].mime_type" />
                </video>
              </div>
            </div>
            <div v-else-if="mediaItem.media_type == 'external_video'"
class="carousel-cell" :key="mediaItem.id">
              <div v-if="OneTrust"
class="video-wrapper">
                <iframe
width="100%" height="100%" :src="youtubeVideo(mediaItem.external_id)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;" allowfullscreen />
              </div>
              <div v-else>
                <h3>Please accept Targeting cookies to load youtube video</h3>
              </div>
            </div>
          </template>
        </flickity>
        <label id="imgNextBtn">
          <button aria-label="Next image" v-if="media.length > 1" @click="galleryNext">
            <Icon
class="product-gallery__button" name="chevron-right" size="44px" />
          </button>
        </label>
      </div>

      <div v-if="media.length > 1" class="product-gallery__thumbnails">
        <template v-if="media.length <= thumbCount">
          <div :class="[selectedGalleryCell == mediaIndex ? 'thumb-selected' : '']"
@click="selectCell(mediaIndex)" v-for="(mediaItem, mediaIndex) in media" :key="mediaItem.id" class="carousel-cell-thumbnail">
            <img
class="product-gallery__thumb lazyload image--fade-in" :data-src="mediaItem.preview_image.src" data-widths="[400,500,600,700,800,900,1000,1100,1200]" data-sizes="auto" :alt="mediaItem.alt ? mediaItem.alt : `${productTitle} Image ${mediaIndex + 1}`" />
            <div v-if="mediaItem.media_type == 'video' || mediaItem.media_type == 'external_video'"
class="product-gallery__thumb-overlay">
              <Icon
name="video-play" size="50px" />
            </div>
          </div>
        </template>
        <template v-else>
          <flickity ref="productGalleryThumbnails"
:options="flickityOptionsThumbs" :class="`product-gallery-thumbs ${lastSlideClass}`"  role="group" aria-label="Product Thumbnails Slider">
            <div :class="[selectedGalleryCell == mediaIndex ? 'thumb-selected' : '']"
@click="selectCell(mediaIndex)" v-for="(mediaItem, mediaIndex) in media" :key="mediaItem.id" class="carousel-cell-thumbnail">
              <img
class="product-gallery__thumb lazyload image--fade-in" :data-src="mediaItem.preview_image.src" data-widths="[400,500,600,700,800,900,1000,1100,1200]" data-sizes="auto" :alt="mediaItem.alt ? mediaItem.alt : `${productTitle} Image ${mediaIndex + 1}`" />
              <div v-if="mediaItem.media_type == 'video' || mediaItem.media_type == 'external_video'"
class="product-gallery__thumb-overlay">
                <Icon
name="video-play" size="50px" />
              </div>
            </div>
          </flickity>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import Flickity from 'vue-flickity';
  import { getSizedImageUrl } from 'scripts/filters/images.js';
  /**
   * @namespace ProductGallery
   * @desc This component serves as a wrapper for the PDP Before + After section.
   *     In the future, this component will integrate with modal and lightbox
   *     components to display images in a lightbox carousel, which is why its
   *     being passed props that aren't used at the moment (3/8/21).
   *     SCSS is written in the global stylesheet to avoid layout shift during render.
   */
  export default {
    name: 'ProductGallery',
    components: {
      Icon,
      Flickity,
    },
    props: {
      media: {
        type: Array,
        default: '',
      },
      OneTrust: {
        type: Boolean,
        default: true,
      },
      productTitle: {
        type: String,
      },
    },
    data() {
      return {
        selectedVariant: {},
        serviceAccordion: false,
        flickityOptions: {
          pageDots: false,
          resize: true,
          adaptiveHeight: true,
          prevNextButtons: false,
          wrapAround: true,
          imagesLoaded: true,
          setGallerySize: true,
          draggable: true,
          cellAlign: 'left',
        },
        flickityOptionsThumbs: {
          pageDots: false,
          resize: true,
          adaptiveHeight: true,
          prevNextButtons: false,
          wrapAround: false,
          imagesLoaded: true,
          contain: true,
          draggable: true,
          asNavFor: '.product-gallery-main',
          cellAlign: 'center',
          groupCells: 1,
        },
        selectedGalleryCell: 0,
        lastSlideClass: '',
      };
    },
    computed: {
      zoomImages() {
        return this.media.map((mediaItem) => {
          return getSizedImageUrl(mediaItem.preview_image.src, '1500x');
        });
      },
      isMobile() {
        return ['mobile', 'tablet'].includes(this.$mq);
      },
      thumbCount() {
        return this.isMobile ? 3 : 4;
      },
    },
    mounted() {
      // setTimeout(() => {
      //   if (window.dataLayer) {
      //     let OnetrustActiveGroups;

      //     window.dataLayer.forEach((value, index, array) => {
      //       if (array[index].OnetrustActiveGroups !== undefined) {
      //         OnetrustActiveGroups = array[index].OnetrustActiveGroups;
      //       }
      //     });

      //     if (OnetrustActiveGroups) {
      //       const specificNumber = "4";
      //       if (OnetrustActiveGroups.includes(specificNumber)) {
      //         this.OneTrust = true;
      //       }
      //     }
      //   }
      // }, 1000);

      let $gallerySlider = this.$refs.flickity;
      let $thumbSlider = this.$refs.productGalleryThumbnails;
      try {
        let self = this;
        $gallerySlider.on('change', function(index) {
          self.selectCell(index);
        });
        $thumbSlider.on('select', function(index) {
          self.lastSlideClass = self.media.length - 1 === index ? 'product-gallery-thumbs--no-more' : '';
        });
      } catch (e) {}
    },
    methods: {
      videoPadding(index) {
        return 'padding-bottom: ' + 100 / this.media[index].aspect_ratio + 'px';
      },
      galleryNext() {
        let currentSlide = this.$refs.flickity.$flickity.selectedIndex + 1;
        if (currentSlide > this.$refs.flickity.$flickity.slides.length - 1) {
          this.selectedGalleryCell = 0;
          this.$refs.flickity.selectCell(0);
        } else {
          this.selectedGalleryCell = currentSlide;
          this.$refs.flickity.selectCell(currentSlide);
        }
      },
      galleryPrevious() {
        let currentSlide = this.$refs.flickity.$flickity.selectedIndex - 1;
        if (currentSlide < 0) {
          let totalSlides = this.$refs.flickity.$flickity.slides.length - 1;
          this.selectedGalleryCell = totalSlides;
          this.$refs.flickity.selectCell(totalSlides);
        } else {
          this.selectedGalleryCell = currentSlide;
          this.$refs.flickity.selectCell(currentSlide);
        }
      },
      selectCell(index) {
        this.selectedGalleryCell = index;
        this.$refs.flickity.selectCell(index);
      },
      youtubeVideo(videoID) {
        return 'https://www.youtube.com/embed/' + videoID;
      },
      zoom(event) {
        let container = event.currentTarget;
        let imgZoom = container.querySelector('.product-gallery__image--zoom');

        let zoomDimensions = {
          w: imgZoom.offsetWidth,
          h: imgZoom.offsetHeight,
        };

        let rect = container.getBoundingClientRect();

        let position = {
          x: Math.round(((event.clientX - rect.left) / zoomDimensions.w) * 100),
          y: Math.round(((event.clientY - rect.top) / zoomDimensions.h) * 100),
        };

        imgZoom.style.backgroundPosition = `${position.x}% ${position.y}%`;
      },
    },
  };
</script>
